import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'g-button',
  templateUrl: './g-button.component.html',
  styleUrls: ['./g-button.component.scss']
})
export class GButtonComponent implements OnInit {
  @Input() loading: boolean;
  @Input() isDisabled: boolean;
  @Input() text: string;
  @Input() icon: string;
  @Input() buttonType: 'primary' | 'primary-outline' | 'secondary' | 'submit' | 'secondary-outline' | 'danger' | 'simple' | 'simple-squared-outline' = 'primary';
  @Input() type: string = 'button';
  @Input() size: string = 'normal';
  @Input() isFullWidth: boolean = false;
  @Input() isRoundBorder: boolean = true;
  @Output() triggerClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public onClick() {
    if (!this.isDisabled && !this.loading) {
      this.triggerClick.emit();
    }
  }
}
